import { useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@material-ui/pickers/DatePicker";

import ApiButton from "../../../../../shared/ui/Api.Button";

const RemoveOptions = ({ removeOption, item, removeFees }) => {
  let datePickerVisible = false;
  let typePickerVisible = false;
  let buttonVisible = true;
  let menuItems = [
    <MenuItem value="IntermediationFee" key={1}>
      Intermediation Fee
    </MenuItem>,
    <MenuItem value="OtherFees" key={2}>
      Other Fees
    </MenuItem>,
    <MenuItem value="KFMFee" key={3}>
      KFM Fee
    </MenuItem>,
    <MenuItem value="CollectionFee" key={4}>
      Collection Fee
    </MenuItem>,
    <MenuItem value="InvoiceFee" key={5}>
      Admin Fee
    </MenuItem>,
    <MenuItem value="PenaltyFee" key={6}>
      Penalty Fee
    </MenuItem>,
    <MenuItem value="ReminderFee" key={7}>
      Reminder Fee
    </MenuItem>,
    <MenuItem value="RescheduleFee" key={8}>
      Reschedule Fee
    </MenuItem>,
    <MenuItem value="RenewalFee" key={9}>
      Renewal Fee
    </MenuItem>,
    <MenuItem value="LateFee" key={10}>
      Late Fee
    </MenuItem>,
  ];

  const [date, changeDate] = useState(new Date());
  const [byType, changeByType] = useState();

  switch (removeOption) {
    case "":
      buttonVisible = false;
      break;
    case "byType":
      typePickerVisible = true;
      break;
    case "byTypeOnDate":
    case "byTypeSinceDate":
      typePickerVisible = true;
      datePickerVisible = true;
      break;
    case "allOnDate":
    case "allSinceDate":
      datePickerVisible = true;
      break;
  }

  function _removeFees() {
    let data = { CreditId: item.Id };
    switch (removeOption) {
      case "byType":
        data.Type = byType;
        break;
      case "byTypeOnDate":
      case "byTypeSinceDate":
        data.Type = byType;
        data.Year = date.year();
        data.Month = date.month() + 1;
        data.Day = date.date();
        break;
      case "allOnDate":
      case "allSinceDate":
        data.Year = date.year();
        data.Month = date.month() + 1;
        data.Day = date.date();
        break;
    }

    removeFees(data, removeOption);
  }

  return (
    <div>
      {datePickerVisible ? (
        <div>
          <DatePicker
            inputVariant="outlined"
            className="small-datepicker"
            value={date}
            onChange={changeDate}
            label="Date"
          />
        </div>
      ) : undefined}
      {typePickerVisible ? (
        <div>
          <TextField
            size="small"
            variant="outlined"
            select
            label="Type"
            value={byType}
            onChange={(e) => {
              changeByType(e.target.value);
            }}
          >
            {menuItems}
          </TextField>
        </div>
      ) : undefined}
      {buttonVisible ? (
        <div>
          <ApiButton
            sending={item.sending}
            sent={item.sent}
            error={item.error}
            onButtonClick={_removeFees}
            buttonLabel={"Remove"}
          />
        </div>
      ) : undefined}
    </div>
  );
};

export default RemoveOptions;
